module.exports = __webpack_public_path__ + "static/media/NO_SALT.c718b57d.svg";